import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { BotonUpim } from '../components/ui-upim';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <Layout showFooter={false}>
      <div className="upim-halo relative flex min-h-[80vh] items-center overflow-hidden" data-testid="pagina-404">
        <div className="upim-aparece relative mx-auto w-full max-w-3xl px-5 sm:px-8 lg:px-12">
          <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.26em] text-[var(--upim-acento)]">
            Error 404
          </p>
          <h1 className="mb-6 font-display text-[5rem] font-extrabold leading-none tracking-tighter text-[var(--upim-texto)] sm:text-[7rem]">
            404
          </h1>
          <h2 className="mb-4 font-display text-2xl font-bold text-[var(--upim-texto)] md:text-3xl">
            Página no encontrada
          </h2>
          <p className="mb-10 max-w-md text-sm leading-relaxed text-[var(--upim-texto-2)] md:text-base">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
          <div className="flex flex-col gap-4 sm:flex-row">
            <BotonUpim as={Link} to="/" variante="solido" testId="404-inicio">
              <Home className="h-5 w-5" aria-hidden="true" />
              Ir al inicio
            </BotonUpim>
            <BotonUpim as={Link} to="/contacto" variante="contorno" testId="404-contacto">
              <ArrowLeft className="h-5 w-5" aria-hidden="true" />
              Contactar soporte
            </BotonUpim>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
